import { Badge, Button, Card, Empty, Table, Tabs } from 'antd';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { Product } from '../../models/product-interface';
import { ProductQueries } from '../../queries/product-queries';
import { cancel } from '../../utilites/api';
import { ShortDateStringForUser } from '../../utilites/dateTimeHelper';
import moment from 'moment';

function ProductPage() {

    const productQuery = ProductQueries.useProducts();
    const [activeKey,setActiveKey] = useState<string>("products");
    const isLoading = productQuery.isLoading;
    const history = useHistory();

    useEffect(() => {
        document.title = `Govenda CS: Products`;

        
        return () => {
            cancel('Products page unmounted');
        }
    }, []);


    const tabList = !!productQuery.data ? [
    {
        key: 'products',
        tab: "Base Products"
    },
    {
        key: 'addons',
        tab: "Add Ons"
    },
    {
        key: "legacy",
        tab: "Legacy"
    }
    ] : []
    
    const filteredData = ():Product[] => {
        if(!!!productQuery.data) return []
        if(activeKey === "legacy") {
            return productQuery.data.filter(x => x.legacy_flag && x.category !== "Miscellaneous Products" && x.category !== "Services" && x.category !== "Service")
        } else {
            let category = activeKey === "products" ? "Base Products" : "Add On Services"
            return productQuery.data.filter(x => (x.legacy_flag == null || !x.legacy_flag) && (x.category === category || (
              (category == "Base Products" && x.category == "Core Subscription") ||
              (category == "Add On Services" && x.category == "Add-On Subscription") ||
              (category == "Add On Services" && x.category == "Add-on")
            )))
        }
    }

    
  const columns: any = [
    {
      title: 'Product ID',
      dataIndex: 'id',
      key: 'productId',
      render: (id: number, record: Product) => {
        return (id
        )
      },
      hidden: false,
      width: 120,
      sorter: {
        compare: (a: Product, b: Product) =>
          a.id === b.id ? 0 : a.id > b.id ? -1 : 1
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: Product) => {
        return (
          <Button
            type="link"
            href={`/admin/products/${record.id}`}
            onClick={(e) => {
              e.preventDefault();
              history.push(`/admin/products/${record.id}`)
            }}
          >
            {name}
          </Button>
        )
      },
      hidden: false,
      sorter: {
        compare: (a: Product, b: Product) =>
          a.name.localeCompare(b.name)
      },
    },
    
    {
        title: 'Type',
        dataIndex: 'category',
        key: 'category',
        render: (category: string, record: Product) => {
          return (category)
        },
        hidden: activeKey !== "legacy",
        sorter: {
          compare: (a: Product, b: Product) =>
            a.category.localeCompare(b.category)
        },
      },
    {
      title: 'Current Version',
      dataIndex: 'version',
      key: 'version',
      width: 170,
      render: (version: number, record: Product) => {
        return (
          version
        )
      },
      hidden: false,
      sorter: {
        compare: (a: Product, b: Product) =>
        a.version === b.version ? 0 : a.version > b.version ? -1 : 1
      },
    },
    {
      title: 'Last Updated',
      dataIndex: 'updated_date',
      key: 'updated_date',
      hidden: false,
      render: (date?: Date) => {
        return date !== null ? ShortDateStringForUser(date, 1) : null;
        },
        sorter: { 
            compare: (a: { updated_date: moment.MomentInput; }, b: { updated_date: moment.MomentInput; }) => moment(a.updated_date).diff(moment(b.updated_date))
        },
    },
  ];



  return <Card loading={isLoading} title="Products" tabList={tabList} activeTabKey={activeKey} onTabChange={key => {
                setActiveKey(key);
            }}>
    <Table
        columns={columns.filter(x => !x.hidden)}
        dataSource={filteredData()}
        rowKey={(val) => val.id}
        size="middle"
        locale={{
        emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={`No products found`} />
        }}
        scroll={{ x: 715 }}
        pagination={{defaultPageSize: 20}}
    />
  </Card>
}


export default ProductPage;